import * as yup from "yup";

import { BoxProps, Button, ButtonProps, Divider, LinkProps, Text } from "@chakra-ui/react";
import { AppForm, FormField, FormFieldProps, Link } from "@picovico/ui";

import { parseApiError } from "@picovico/utils";
import { useForgotPasswordMutation } from "@store/services/auth";
import { isString } from "lodash";
import { useRouter } from "next/router";
import { useAppToast } from "@/hooks/useAppToast";

export interface forgotPasswordValues {
  email: string;
}

const forgotPasswordFormValidationSchema = yup.object().shape({
  email: yup.string().email().required().label("Email"),
});

const initialValues: forgotPasswordValues = {
  email: "",
};

interface ForgotPasswordFormProps extends BoxProps {
  buttonProps?: ButtonProps;
  formProps?: BoxProps;
  formFieldProps?: FormFieldProps;
  emailFieldProps?: FormFieldProps;
  returnToLoginLinkProps?: LinkProps;
}

function ForgotPasswordForm({
  buttonProps,
  formFieldProps,
  emailFieldProps,
  returnToLoginLinkProps,
  ...props
}: ForgotPasswordFormProps) {
  const router = useRouter();
  const { success } = useAppToast();
  const [requestPasswordChange, { isLoading, error }] =
    useForgotPasswordMutation({});

  return (
    <AppForm<forgotPasswordValues>
      formProps={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",
        gap: "1rem",
        mt: "1.5rem",
        ...props,
      }}
      apiError={(error && parseApiError(error)) || null}
      initialValues={initialValues}
      validationSchema={forgotPasswordFormValidationSchema}
      onSubmit={(values) => {
        requestPasswordChange(values)
          .unwrap()
          .then((res) => {
            if (res?.data) {
              success(isString(res?.data) ? res?.data : res?.data?.message);
              router.push("/login");
            }
          });
      }}
    >
      <FormField name="email" label="Email" {...formFieldProps} {...emailFieldProps} />

      <Button
        isLoading={isLoading || false}
        isDisabled={isLoading || false}
        mt="1rem"
        w="full"
        type="submit"
        {...buttonProps}
      >
        Continue
      </Button>
      <Divider my="1rem" />
      <Text mx="auto" fontWeight={500}>
        <Link
          href="/login"
          color="primary.500"
          _hover={{ color: "primary.700" }}
          {...returnToLoginLinkProps}
        >
          Return to login
        </Link>
      </Text>
    </AppForm>
  );
}

export default ForgotPasswordForm;
